export default "__VITE_ASSET__qin9n6UI__"